/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'magic-wand-2': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" transform="rotate(-45.001 9.302 14.617)" d="M1.804 13.617h14.999v2H1.804z" _fill="#767676"/><path pid="1" transform="rotate(-45.001 17.435 6.485)" d="M15.435 5.485h4.001v2h-4.001z" _fill="#767676"/><path pid="2" transform="rotate(-75.001 18.988 12.282)" d="M17.988 10.281h2v4.001h-2z" _fill="#767676"/><path pid="3" transform="scale(-1) rotate(75.008 21.53 -19.213)" d="M12.744 15.523h4.001v2h-4.001z" _fill="#767676"/><path pid="4" transform="rotate(75.001 11.64 4.932)" d="M9.64 3.932h4v2h-4z" _fill="#767676"/><path pid="5" transform="rotate(14.999 7.396 9.173)" d="M5.397 8.175h4.001v1.999H5.397z" _fill="#767676"/>'
  }
})
